import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]

import { useI18n } from 'vue-i18n'
  import { BookingSummary } from '@/services/BookingService.interface'
  import { UserInfo } from '@/services/AuthService.interface'
  import { computed } from 'vue'

  // Composables
  import { useBookingStatus } from '@/composables/useBookingStatus'
  import Cookies from 'js-cookie'
  import { CookieName } from '@/config/cookies'
  import { LocaleEnum } from '@/config'

  // Props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentButton',
  props: {
    userId: {},
    booking: {}
  },
  setup(__props: any) {

  const props = __props

  // i18n instance
  const { t } = useI18n()

  // Computed property to check if payment should be disabled
  const isPaymentDisabled = computed(() => {
    return props.booking.reference.startsWith('BO') && 
           (props.booking.packageCode === 'PFF' || props.booking.packageCode === 'PFPF')
  })

  // Function to handle legacy locale conversion
  const handleLegacyLocale = (url: URL): void => {
    const currentLocale = url.searchParams.get('locale')
    if (currentLocale === LocaleEnum.EN_GB) {
      url.searchParams.set('locale', LocaleEnum.EN_US)
    }
  }

  // Handle payment logic
  const handlePayment = (): void => {
    if (!props.userId || !props.booking) {
      console.error(
        'User ID and booking information are required to proceed with payment.'
      )
      return
    }

    let paymentLink: string | undefined = props.booking.paymentLink
    if (!paymentLink) {
      console.error('Missing payment link')
      return
    }

    const company = Cookies.get(CookieName.COMPANY)
    const updatedPaymentLink = new URL(paymentLink, window.location.origin)

    // Apply legacy locale conversion
    handleLegacyLocale(updatedPaymentLink)

    // Add company parameter if available
    if (company) {
      updatedPaymentLink.searchParams.set('company', company)
    }

    // Open the updated payment link in a new tab
    window.open(updatedPaymentLink.href, '_blank')
  }

  const { isReservationStatus } = useBookingStatus(props.booking)

return (_ctx: any,_cache: any) => {
  return (_unref(isReservationStatus) && _ctx.booking.leftToPay && _ctx.booking.leftToPay > 0)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "button-primary primary-normal small action-button",
        disabled: isPaymentDisabled.value,
        onClick: handlePayment
      }, _toDisplayString(_unref(t)('reservations.payBalance')), 9, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})